// extracted by mini-css-extract-plugin
module.exports = {"error":"Appointment_error__25BXT","success":"Appointment_success__3ht_u","required":"Appointment_required__2ZsTE","form":"Appointment_form__20I3u"};